<template>
  <div>
    <v-header></v-header>
    <iframe :style="`width:100%;height:${height}px`" src="https://s0vefqbru5.feishu.cn/docx/TG7RdXkUioo1Fux1daMcLQcXnRt"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      height: window.innerHeight - 80
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Feishu.vue